import React from 'react';
import styled from 'styled-components';

const PolicyInner = styled.div`
  overflow: auto;
  max-height: 400px;
  font-size: 17px;
  .open-terms {
    color: #0093dd;
    cursor: pointer;
  }
  h1 {
    text-align: center;
    line-height: 1;
    font-size: 45px;
    margin-bottom: 15px;
  }
  h2 {
    font-size: 26px;
    color: #444;
  }
  i {
    font-size: 15px;
    text-align: center;
    display: block;
    width: 100%;
  }
  p {
    font-size: 16px;
  }
`;

const PolicyWrapper = styled.div`
  position: relative;
  x-index: 999999;
  background: #fff;
  width: calc(100% - 40px);
  max-width: 700px;
  margin: 30px auto;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
  padding: 20px;
  padding-bottom: 70px;
`;

const Controls = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  background: #fff;
  width: calc(100% - 40px);
  padding: 10px;
`;

const Button = styled.button`
  background: #0093dd;
  display: block;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  padding: 10px;
  width: 100px;
  border: none;
  margin: 0 auto;
  &:focus {
    outline: none;
  }
  &:hover {
    background: #0165fc;
  }
`;

const t = 'Smart Tracker';

const Policy: React.FC<{ close: () => void; openTerms: () => void }> = (props) => {
  return (
    <PolicyWrapper>
      <PolicyInner>
        <h1>Политика конфиденциальности</h1>
        <i>Последнее обновление: 12 января 2022 г.</i>
        <h2>1. Сфера применения</h2>
        <p>
          Эта политика распространяется на всех пользователей {t}, а также на вебсайт и приложение
          (совместно именуемые «Сервисы {t}»). Использование вами сервисов {t} регулируется нашим{' '}
          <span onClick={props.openTerms} className="open-terms">
            Лицензионным соглашением
          </span>
          . Получая доступ или используя любую часть сервиса {t}, вы подтверждаете, что были
          проинформированы и соглашаетесь с нашими методами в отношении вашей личной информации и
          данных.
        </p>
        <h2>2. Информация, которую мы собираем</h2>
        <p>
          Когда вы используете Сервис {t}, мы собираем предоставляемую вами информацию а также
          информацию с которой вы работаете, когда включаете трекер. Вот типы информации, которую мы
          собираем о вас:
        </p>
        <ul>
          <li>
            А) Информация, которую вы нам предоставляете
            <p>
              <b>Регистрация аккаунта.</b> Когда вы создаете учетную запись в {t}, мы сохраняем в
              базе данных вашу электронную почту и пароль. Если вы захотите пользоваться платными
              услугами сервиса, мы также сохраняем вашу платежную информацию в виде квитанций.
            </p>
          </li>
          <li>
            Б) Информация, которую мы собираем, когда вы используете платформу
            <p>
              <b>Информация об использовании</b>. Мы собираем информацию об использовании вами
              Сервиса {t}, включая время начала работы, время завершения работы, задачи или проекты,
              над которыми работали и снимки экрана вашего рабочего стола. Настольное приложение {t}{' '}
              НЕ записывает физическую локацию места вашей работы, так как мы не используем данных в
              виде IP адресов пользователей.
            </p>
          </li>
        </ul>
        <h2>3. Как мы используем вашу информацию</h2>
        <p>
          <b>Предоставление Сервиса {t}</b>. Мы стараемся предоставить интуитивно понятный,
          эффективный и полезный инструмент для вашего бизнеса. Поэтому ваша личная информация нам
          нужна чтобы:
          <ul>
            <li>
              Подтвердить вашу личность и сохранить вашу учетную запись в случае утраты вами доступа
              к аккаунту
            </li>
            <li>Обрабатывать платежи</li>
            <li>Общаться с вами о вашем опыте</li>
            <li>Собирать отзывы о вашем опыте</li>
          </ul>
          <b> Поддержание безопасности Сервиса {t} и ее пользователей.</b> Предоставление вам
          безопасной и надежной работы является краеугольным камнем нашего Сервиса. Поэтому ваша
          личная информация нам нужна чтобы:
          <ul>
            <li>Аутентифицировать пользователей</li>
            <li>Выявлять и предотвращать мошенничество.</li>
            <li>Блокировать и удалять небезопасных или мошеннических пользователей с Сервиса.</li>
          </ul>
          <b>Обеспечение поддержки клиентов</b>. Мы прилагаем все усилия, чтобы обеспечить наилучший
          возможный опыт, включая поддержку, когда вам это нужно. Поэтому ваша личная информация нам
          нужна чтобы:
          <ul>
            <li>Исследовать и помочь вам в решении вопросов или проблем, связанных с Сервисом</li>
            <li>Предоставить вам поддержку или ответить на возникшие вопросы.</li>
          </ul>
          <b>Улучшение Сервиса {t}</b>. Мы всегда работаем над тем, чтобы улучшить ваш опыт и
          предоставить вам новые и полезные функции. Поэтому ваша личная информация нам нужна чтобы:
          <ul>
            <li>Проводить исследования, тестирование и анализ</li>
            <li>Разрабатывать новые продукты, функции и услуги </li>
            <li>
              Предотвращать, находить и устранять программные или аппаратные ошибки и проблемы
            </li>
            <li>
              Отслеживать и улучшать наши операции и процессы, включая методы обеспечения
              безопасности, алгоритмы и другое моделирование.
            </li>
          </ul>
          <b>Реагирование на судебные разбирательства и требования</b>. Иногда закон,
          государственные органы или другие регулирующие органы налагают на нас требования и
          обязательства в отношении услуг, которые мы стремимся предоставлять. В таком случае мы
          можем использовать вашу личную информацию, чтобы ответить на эти требования или
          обязательства.
        </p>
        <h2>4. Как мы передаем вашу информацию</h2>
        <p>
          Мы не продаем вашу личную информацию. Чтобы Сервис {t} работал, нам может потребоваться
          передать вашу личную информацию другим пользователям или третьим лицам вне сервиса. В этом
          разделе объясняется, когда и почему мы передаем вашу информацию.
        </p>
        А) Совместное использование между пользователями {t}
        <p>
          <b>Ваша компания и менеджеры</b>. Информация об использовании веб-сайта и приложения,
          которую мы собираем, передается администратору вашей компании, вашему менеджеру
          (менеджерам), назначенному администратором вашей компании, и вам. Мониторинг снимков
          экрана активен для всех пользователей системы, когда они активно отслеживают время.
        </p>
        Б) По юридическим причинам и для защиты Сервиса {t}
        <p>
          Мы можем передавать вашу личную информацию в ответ на юридическое обязательство или если
          мы определили, что передача вашей личной информации разумно необходима или уместна для:
        </p>
        <ul>
          <li>
            Соблюдения любых применимых федеральных, государственных или местных законов или
            постановлений, гражданских, уголовных или нормативных расследований, расследований или
            судебных процессов или обязательных для исполнения правительственных запросов;
          </li>
          <li>
            Ответов на судебный процесс (например, ордер на обыск, повестку в суд, повестку или
            постановление суда)
          </li>
          <li>Обеспечения соблюдения наших Условий обслуживания</li>
          <li>
            Сотрудничества с правоохранительными органами в отношении поведения или деятельности,
            которые, по нашему разумному и добросовестному мнению, могут нарушать федеральный закон,
            закон штата или местный закон
          </li>
          <li>
            Осуществления или защиты судебных исков, защиты от нанесения ущерба нашим правам,
            имуществу, интересам или безопасности или правам, имуществу, интересам или безопасности
            вас, третьих лиц или общества, как это требуется или разрешено законом.
          </li>
        </ul>
        В) В связи с продажей или слиянием
        <p>
          Мы можем передавать вашу личную информацию во время переговоров или в связи с изменением
          корпоративного контроля, таким как реструктуризация, слияние или продажа наших активов.
        </p>
        Г) После вашего дальнейшего указания
        <p>
          С вашего разрешения или по вашему указанию мы можем раскрыть вашу личную информацию для
          взаимодействия с третьей стороной или для других целей.
        </p>
        <h2>5. Как мы храним и защищаем вашу информацию</h2>
        <p>
          Мы храним вашу информацию до тех пор, пока это необходимо для предоставления вам и другим
          нашим пользователям Сервиса {t}. Это означает, что мы храним информацию вашего профиля до
          тех пор, пока вы поддерживаете учетную запись. Мы храним информацию о транзакциях не менее
          семи лет, чтобы гарантировать, что мы можем выполнять законные бизнес-функции, такие как
          учет налоговых обязательств. Если вы запросите удаление учетной записи, мы удалим вашу
          информацию.
        </p>
        <p>
          Мы принимаем разумные и надлежащие меры, направленные на защиту вашей личной информации. К
          ним относятся:
        </p>
        <ul>
          <li>Зашифрованная передача данных (HTTPS)</li>
          <li>Строгая политика управления паролями</li>
        </ul>
        <h2>6. Ссылки на сторонние веб-сайты</h2>
        <p>
          Сервис {t} может содержать одну ссылку на сторонний веб-сайт. Это веб-сервис по приему
          платежей <a href="https://portal.fondy.eu/">FONDY</a>. Он может иметь политику
          конфиденциальности, отличную от нашей. Мы не несем ответственности за этот веб-сайт и
          рекомендуем вам ознакомиться с их политикой. Пожалуйста, свяжитесь с этим веб-сайтом
          напрямую, если у вас есть какие-либо вопросы об их политике конфиденциальности.
        </p>
        <h2>7. Изменения в настоящей Политике конфиденциальности</h2>
        <p>
          Мы можем время от времени обновлять эту политику по мере изменения Сервиса {t} и развития
          законодательства о конфиденциальности. Если мы обновим его, мы сделаем это онлайн, а если
          мы внесем существенные изменения, мы сообщим вам об этом через Сервис {t} или каким-либо
          другим способом связи, например, по электронной почте. Когда вы используете {t}, вы
          соглашаетесь с последними условиями этой политики.
        </p>
        <h2>8. Свяжитесь с нами</h2>
        <p>
          Если у вас есть какие-либо вопросы или опасения по поводу вашей конфиденциальности или
          чего-либо в этой политике, в том числе если вам нужен доступ к этой политике в
          альтернативном формате, мы рекомендуем вам связаться с нами по электронной почте{' '}
          <a href="mailto:saynschuman@gmail.com">saynschuman@gmail.com</a> или по телефону{' '}
          <a href="skype:+380674052632">+38 (067) 405 26 32</a>.
        </p>
      </PolicyInner>
      <Controls>
        <Button type="button" onClick={props.close}>
          Ознакомлен
        </Button>
      </Controls>
    </PolicyWrapper>
  );
};

export default Policy;
